<template>
<div class='fw-card'
     :class='color'
     @click='$emit("click", data)'>
    <div v-if='showImage'>
        <div class='fw-card__background-image'
             :style='backgroundImageStyle'></div>
    </div>

    <div class='fw-card__content'>
        <div class='fw-card__title'>
            {{ title }}
        </div>
        <div class='fw-card__text'>
            <slot></slot>
        </div>
        <div v-if='date || number'
             class='fw-card__aside-wrapper'>
            <div v-if='date'
                 class='fw-card__aside'>
                <div class='fw-card__aside-title'>
                    Date
                </div>
                <div class='fw-card__aside-content'>
                    {{ date }}
                </div>
            </div>
            <div v-if='number'
                 class='fw-card__aside'>
                <div class='fw-card__aside-title'>
                    Numero
                </div>
                <div class='fw-card__aside-content'>
                    {{ number }}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

const AVAILABLE_COLORS: Array<string> = ['blue', 'green', 'yellow', 'red', 'violet', 'orange'];
const AVAILABLE_TYPES: Array<string> = ['horizontal', 'vertical'];

@Component({
    inheritAttrs: false,
    model: {
        event: 'update',
    },
})
export default class FwCard extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String }) readonly date!: string;
    @Prop({ type: Number }) readonly number!: number;
    @Prop({ type: Object, default: null }) readonly data!: any;
    @Prop({ type: Boolean, default: true }) readonly showImage!: boolean;
    @Prop({ type: String, required: true, validator: (type: string) => AVAILABLE_COLORS.includes(type) }) readonly color!: string;
    @Prop({ type: String, required: true, validator: (type: string) => AVAILABLE_TYPES.includes(type) }) readonly type!: string;

    get backgroundImageStyle() {
        return {
            // @ts-ignore-next-line
            backgroundImage: `url(${this.requireFwImage(`orders/${this.color}.png`)})`,
        };
    }
};
</script>

<style lang='sass'>
.fw-card
    display: flex
    width: 100%
    border-radius: 40px
    background-color: #fff
    box-shadow: 0 16px 28px 15px rgba(0, 0, 0, 0.05)
    padding: 37px 30px 23px 70px
    position: relative
    overflow: hidden

    &__content
        width: 100%

    &__title
        font-size: 22px
        line-height: 25px
        height: 2.2em
        overflow: hidden
        margin-bottom: 5px
        font-weight: 500

    &__text
        color: $dark-blue
        font-size: 18px
        font-weight: 300
        line-height: 20px
        margin-bottom: 10px

    &__aside
        flex: 1 0
        display: flex
        flex-direction: column

    &__aside-title
        font-weight: 500
        font-size: 16px
        line-height: 19px
        letter-spacing: 0.3px
        color: $main-gray
        text-transform: uppercase
        margin-bottom: 5px

    &__aside-content
        font-size: 16px
        letter-spacing: 0.3px
        color: $dark-blue
        font-weight: 500

    &__aside-wrapper
        display: flex

    &.red
        .title
            color: $red-card-color

    &.green
        .title
            color: $green-card-color

    &.yellow
        .title
            color: $yellow-card-color

    &.orange
        .title
            color: $orange-card-color

    &.violet
        .title
            color: $violet-card-color

    &.blue
        .title
            color: $blue-card-color

    &__background-image
        left: 0
        position: absolute
        top: 0
        height: 100%
        width: 60px
        background-size: auto 100%
        background-position: -70px
        background-repeat: no-repeat

        &:after
            content: ''
            width: 40px
            background: #fff
            border-radius: 40px 0 0 40px
            height: 100%
            position: absolute
            right: 0
</style>
